module.exports = __webpack_public_path__ + "img/defaultDirectory.50538f90.png";